<div class="edit-visitor-role-task-dialog">
  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="tmc-visit.ui.visitor-role.edit-task-title"></sc-dictionary-label>
  </sc-dialog-title>
  <sc-padding class="no-field-space">
    <form [formGroup]="formGroup">
      <sc-dictionary-field [model]="task.name" labelDictionaryKey="tmc-visit.entity.visitor-role-task.name"></sc-dictionary-field>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-number-field formControlName="validity" labelDictionaryKey="tmc-visit.entity.visitor-role-task.validity"></sc-number-field>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-checkbox-field formControlName="optional" labelDictionaryKey="tmc-visit.entity.visitor-role-task.optional"></sc-checkbox-field>
    </form>
  </sc-padding>
  <sc-padding>
    <sc-flex>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button (click)="cancel()"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-confirm-button primary (click)="confirm()"></sc-confirm-button>
    </sc-flex>
  </sc-padding>
</div>
